import { useCallback } from 'react';

import { storage } from '../oidc-client';
import { useOidcConfig } from './useOidcConfig';

export function useClearStorageCredential() {
  const { client_id, authority } = useOidcConfig();

  return useCallback(async () => {
    if (storage) {
      await storage.remove(`user:${authority}:${client_id}`);
    }
  }, [authority, client_id]);
}
